var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.className,style:(_vm.iconStyle)},[_c('img',{staticClass:"icon",style:({
      width: (_vm.width || _vm.size) + 'px',
      height: (_vm.height || _vm.size) + 'px',
    }),attrs:{"src":_vm._url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }